import styled from 'styled-components';

const CollapsibleItemStyles = styled.div`
  * {
    box-sizing: border-box;
  }
  display: flex;
  flex-direction: column;

  .container {
    display: flex;    
    cursor: pointer;
  }

  .title {
    padding: 0;
    display: flex;
    align-items: center;
  }

  .chevronContainer {
    margin-left: 5px;
    display: flex;
    align-items: center;
  }

  .content {
    margin-left: 68px;
    p {
      padding: 0;
      margin: 0;
      a {
        padding: 0.2rem 0;
      }
      span {
        padding: 0;
        margin: 0;
      }
    }
  }
`;

export default CollapsibleItemStyles;
